import { isJSXElement } from "@utils/common";
import Image from "next/image";

export interface PageSummaryItem {
    title: string;
    description?: string;
}
export interface PageSummaryBoxProps {
    summaryItems: PageSummaryItem[];
    mediaURL?: string;
    mediaAltTxt?: string;
    image?: JSX.Element;
    containerStyle: string;
    imageStyle: string;
}

const PageSummaryBox: React.FC<PageSummaryBoxProps> = (props) => {
    const { summaryItems, mediaURL, mediaAltTxt, image, containerStyle, imageStyle } = props;
    return (
        <div className="max-w-6xl mx-auto flex lg:flex-row items-center flex-col gap-7 w-full lg:py-0 py-10">
            <div className={`lg:order-2 ${containerStyle} w-full lg:text-left text-center lg:px-0 px-2 gap-4`}>
                {summaryItems.map((item, index) => {
                    const { title, description } = item;
                    return (
                        <div key={index}>
                            {index === 0 ? (
                                <>
                                    <div className="flex flex-col gap-9">
                                        <h2 className={`lg:text-3xl text-2xl text-gray-600 font-bold ${description ? "mb-0" : "mb-9"}`}>{title}</h2>
                                        {description && <p className="text-base text-gray-500 pb-3">{description}</p>}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <h4 className="lg:text-2xl text-xl text-gray-600 font-medium pb-3 ">{title}</h4>
                                    {description && <p className="text-base text-gray-500 pb-3">{description}</p>}
                                </>
                            )}
                        </div>
                    );
                })}
            </div>
            <div className={`${imageStyle} w-full lg:px-0 px-4 md:flex md:justify-center`}>
                {image && isJSXElement(image) ? image : <Image width={480} height={540} loading="lazy" src={mediaURL ?? ""} alt={mediaAltTxt ?? ""} />}
            </div>
        </div>
    );
};
export default PageSummaryBox;
